/*
 * @Author: W9013327 v-maijiahua@oppo.com
 * @Date: 2023-03-02 17:04:18
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-03-23 18:12:00
 * @FilePath: \sns-user-frontend\src\jsBridgeApi\oneplusStore.js
 * @Description: 
 */

import { setCookie } from '@/utils'
export default {
	/**
   * @description 打开窗口/拉起app
   * @param {String} url 
   * @param {Number} flags  128：拉起app 
   * @returns 
   */
  openBrowser(url) {
    try {
      window.OnePlusClientBaseJS.openBrowser(url || location.href)
    } catch {
      window.open(url)
    }
  },
  // 隐藏客户端头部
  hideClientTitle () {
		window.OnePlusClientBaseJS.hideTitleBar()
	},
  closeLoading () {
    
  },
  // 开启新容器
	openNewWebview (url) {
		if (window.OnePlusClientBaseJS) {
			window.OnePlusClientBaseJS.openWebViewActivity(url)
		} else {
      // location.href = url
      window.open(url)
    }
	},
	// 调起客户端给登录页面
	loginPage () {
    window.OnePlusClientUserJS.login()
	},
	// 获取登录态
	async getToken () {
    const res = await window.OnePlusClientBaseJS.getToken()
    setCookie("token", res);
		return res
	},
	// 返回上一级/销毁当前容器
	goBack (callback = null) {
		window.OnePlusClientBaseJS.finish()
	},
	/**
	 * @param {
	 *      title: "分享标题", // 分享标题
	 *      desc: "分享内容", // 分享详细描述
	 *      link: "testhttp://www.baidu.com", //链接
	 *      imgUrl:
	 *      "https://assorted.downloads.oppo.com/static/assets/products/encoM1/		images/1080/m1_3-947cf2d608f8b6b5fddbd07939fc7c18.jpg", // 分享图片
	 *      type: "link", // 分享资源的类型 可选link  music   video   image，当非link时，dataUrl字段不能为空
	 *      dataUrl: "https://assorted.downloads.oppo.com/static/assets/products/encoM1/images/1080/m1_1-977729f43e36d53a5912d792d17a7f5d.jpg"
	 * }
	 */
	share (data) {
    const {link, title } = data
    window.OnePlusClientBaseJS.popShare(JSON.stringify({
      url: link,
      title,
    }))
	},
  async getPackageName () {
    const data = await window.OnePlusClientBaseJS.getPackageName()
    return data
  },
  // 监听返回页面回调
	onResume(callback) {
		window.OnePlusClientBaseJS.registeAction("onResume", () => {
			typeof callback === "function" && callback();
		});
		// window.HeytapJsApi.registeAction("prevExit", () => {
		// 	typeof callback === "function" && callback();
		// });
	}
}